import {LitElement} from 'lit';
import tippy, {Instance as TippyInstance, Props} from 'tippy.js';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Constructor<T = {}> = new (...args: any[]) => T;

export interface IToolTippy {
  tooltip: TippyInstance;
  tooltipContent: () => string;
  _updateTooltip?(): void;
}

export function ToolTippy<T extends Constructor<LitElement>>(
  superClass: T,
  tippyOptions?: Partial<Props>
) {
  class ToolTippyClass extends superClass {
    /** This element's tooltip instance. */
    tooltip: TippyInstance = tippy(this);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args: any[]) {
      super(...args);
      this.tooltip.setProps({
        allowHTML: true,
        interactive: false,
        interactiveBorder: 10,
        maxWidth: 'none',
        delay: [350, 0],
        duration: [null, 0],
        appendTo: document.body,
        ...tippyOptions,
      });
      setInterval(this._updateTooltip.bind(this), 100);
    }
    override disconnectedCallback(): void {
      super.disconnectedCallback();
      // this.tooltip.destroy();
    }
    /**
     * This element's tooltip content.
     * @returns The tooltip content for this element.
     */
    tooltipContent() {
      return '';
    }
    /**
     * Updates this element's tooltip with the latest content.
     */
    _updateTooltip() {
      this.tooltip.setContent(this.tooltipContent());
    }
  }
  return ToolTippyClass as Constructor<IToolTippy> & T;
}
